import { render, staticRenderFns } from "./CollaboratorsSelectionForm.vue?vue&type=template&id=83eabb42&scoped=true"
import script from "./CollaboratorsSelectionForm.vue?vue&type=script&lang=js"
export * from "./CollaboratorsSelectionForm.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorsSelectionForm.vue?vue&type=style&index=0&id=83eabb42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eabb42",
  null
  
)

export default component.exports